<script setup>
// Ikona dyscypliny etapu rajdu (/ar): kółko w kolorze dyscypliny z palety (--sledz-stage-*) i ikona
// kreską. Dyscyplina zawsze ikoną, nie tylko kolorem (makieta AR1). Kody: utils/ar-results.js.
import { computed, defineProps } from 'vue'
import { STAGE_DISCIPLINES } from '../../utils/ar-results.js'

const props = defineProps({
  discipline: { type: String, default: null },
  size: { type: Number, default: 26 }
})

const code = computed(() => (STAGE_DISCIPLINES.includes(props.discipline) ? props.discipline : 'other'))
const icon = computed(() => {
  switch (code.value) {
    case 'trekking': return 'boot'
    case 'run': return 'run'
    case 'bike': return 'bike'
    case 'kayak':
    case 'packraft': return 'paddle'
    case 'swim': return 'swim'
    case 'ropes': return 'rope'
    case 'orienteering': return 'compass'
    case 'special':
    case 'task': return 'star'
    default: return 'route'
  }
})
const inner = computed(() => Math.round(props.size * 0.62))
</script>

<template>
  <span class="si" :class="`si--${code}`" :style="{ width: `${size}px`, height: `${size}px` }" aria-hidden="true">
    <svg :width="inner" :height="inner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <template v-if="icon === 'boot'">
        <!-- But turystyczny z boku (etap pieszy): cholewka ze sznurówkami, czubek w prawo, gruba podeszwa. -->
        <path d="M6 3h6v6l5 2a4 4 0 0 1 4 4v4H3v-4a6 6 0 0 0 3-5z" />
        <path d="M3 15h18M9.5 6H12M9.5 9H12" />
      </template>
      <template v-else-if="icon === 'run'">
        <circle cx="14.5" cy="4.5" r="1.8" />
        <path d="M5 20l3.5-5 3 1.5 1-4.5 3.5 2.5H20M8.5 11l2.5-3 4 1" />
      </template>
      <template v-else-if="icon === 'bike'">
        <circle cx="6" cy="16" r="3.5" />
        <circle cx="18" cy="16" r="3.5" />
        <path d="M6 16l3.5-7h6L18 16M9.5 9L8 6H6M15.5 9l-3 7" />
      </template>
      <template v-else-if="icon === 'paddle'">
        <path d="M2 15c5 2.5 15 2.5 20 0" />
        <path d="M5 5l14 14" />
        <path d="M4 4.5l2.5 1-1 1z" fill="currentColor" />
        <path d="M20 19.5l-2.5-1 1-1z" fill="currentColor" />
      </template>
      <template v-else-if="icon === 'swim'">
        <circle cx="16" cy="6" r="1.8" />
        <path d="M2 17c2 1.5 4 1.5 6 0s4-1.5 6 0 4 1.5 6 0M6 12l4-3 3 3" />
      </template>
      <template v-else-if="icon === 'rope'">
        <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
        <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
      </template>
      <template v-else-if="icon === 'compass'">
        <circle cx="12" cy="12" r="9" />
        <path d="M15.5 8.5l-2 5-5 2 2-5z" />
      </template>
      <path v-else-if="icon === 'star'" d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z" />
      <template v-else>
        <circle cx="6" cy="18" r="2" />
        <circle cx="18" cy="6" r="2" />
        <path d="M8 18h6a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h6" />
      </template>
    </svg>
  </span>
</template>

<style scoped>
.si {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--sledz-surface);
  background: var(--sledz-stage-other);
}
.si--trekking { background: var(--sledz-stage-trekking); }
.si--run { background: var(--sledz-stage-run); }
.si--bike { background: var(--sledz-stage-bike); }
.si--kayak { background: var(--sledz-stage-kayak); }
.si--packraft { background: var(--sledz-stage-packraft); }
.si--swim { background: var(--sledz-stage-swim); }
.si--ropes { background: var(--sledz-stage-ropes); }
.si--orienteering { background: var(--sledz-stage-orienteering); }
.si--special { background: var(--sledz-stage-special); }
.si--task { background: var(--sledz-stage-task); }
</style>
